import React, { useEffect, useState } from 'react';
import style from './index.scss';
import { Button, Table, Modal, message, Select } from 'antd';
import { TextComponent } from '../../trm/components/TableComponents';
import {
  CustomHeader,
  CustomHeaderMandatory
} from '../../trm/components/CustomHeaderComponent/customHeader';
const SegmentsListing = ({
  apiActions,
  customerTypeList,
  authentication,
  deleteCustomerTypeList
}) => {
  const [visible, setVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [editableField, setEditableField] = useState();
  const [deleteSegmentID, setDeleteSegmentID] = useState();
  const [disabledAddSegment, setDisabledAddSegment] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [submitMode, setSubmitMode] = useState();
  const [cancelBtnToggle, setCancelBtnToggle] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Number of records per page

  const { Option } = Select;

  useEffect(() => {
    apiActions?.getCustomerType();
  }, []);

  useEffect(() => {
    if (dataSource?.length > customerTypeList?.data?.length) {
      setDisabledAddSegment(true);
      setCancelBtnToggle(false);
    } else {
      setDisabledAddSegment(false);
      setCancelBtnToggle(true);
    }
  }, [dataSource]);

  useEffect(() => {
    if (deleteCustomerTypeList?.data === null || undefined) return;
    else {
      if (
        deleteCustomerTypeList?.data?.res?.status !== 200 &&
        deleteCustomerTypeList?.data?.res?.data?.msg !== undefined
      ) {
        message.error(deleteCustomerTypeList?.data?.res?.data?.msg);
      }
      if (deleteCustomerTypeList?.data?.res?.status === 200) {
        const updatedDataSource = dataSource.filter(
          (record) => record.segmentID !== deleteSegmentID
        );
        setDataSource(updatedDataSource);
        setEditableField();
        message.success('Segment deleted successfully');
      }
    }
  }, [deleteCustomerTypeList]);

  useEffect(() => {
    handleSegments(customerTypeList);
  }, [customerTypeList]);

  useEffect(() => {
    checkSaveDisabled();
  }, [dataSource]);

  useEffect(() => {
    if (errorMsg !== '' || null) {
      setIsSaveDisabled(true);
    }
  }, [errorMsg, isSaveDisabled]);

  const handleSegments = (customerTypeList) => {
    let segments = customerTypeList?.data;
    const segs = segments?.map((record) => {
      return {
        key: record.customer.id,
        segmentID: record.customer.id,
        name: record.customer.displayName,
        instancesUsed: record.numberOfInstances,
        isDeleted: false // Add the isDeleted property with a default value of false
      };
    });
    setDataSource(segs);
  };

  const handleAddSegment = () => {
    const newRow = {
      key: '-',
      segmentID: '-',
      name: '',
      instancesUsed: '-',
      productionUsed: '-'
    };
    setDataSource([newRow, ...dataSource]);
    setEditableField('-');
    setSubmitMode('ADD');
    setCurrentPage(1); // Reset current page to 1
  };

  const checkSaveDisabled = () => {
    if (!dataSource) {
      setIsSaveDisabled(true);
      return;
    }
    const isEdited = dataSource.some(
      (record) => record.segmentID === editableField || record.key === '-'
    );
    const isAdded = dataSource.some((record) => record.key === '-');
    const isDeleted = dataSource.some((record) => record.isDeleted);
    setIsSaveDisabled(!isEdited && !isAdded && !(isDeleted && !isAdded));
  };

  const columns = [
    {
      title: <CustomHeader title="Segment ID" />,
      className: style.bgWhite,
      key: 'scenario',
      width: '5%',
      render: (record) => {
        return (
          <TextComponent style={{ color: '#0C8ED7' }} id={record.segmentID} />
        );
      }
    },
    {
      title: <CustomHeaderMandatory title="Segment Display Name" />,
      className: style.bgWhite,
      key: 'name',
      width: '5%',
      // ...

      render: (text, record) => {
        if (record.segmentID === editableField) {
          return (
            <input
              style={{ width: '100%', height: '25px' }}
              value={record.name}
              onChange={(e) => {
                handleSegmentNameUpdate(e, record);
              }}
              pagination={{
                current: currentPage,
                onChange: (page) => setCurrentPage(page)
              }}
              placeholder="Enter Segment Name"
              autoFocus // Add this attribute to focus the input field
            />
          );
        }
        return <TextComponent style={{ color: '#748AA1' }} id={record.name} />;
      }
    },
    {
      title: <CustomHeader title="No. of the Run instances used" />,
      className: style.bgWhite,
      key: 'scenario',
      width: '5%',
      render: (record) => {
        return (
          <TextComponent
            style={{ color: '#748AA1' }}
            id={record.instancesUsed}
          />
        );
      }
    },
    // {
    //   title: <CustomHeader title="Used in Production" />,
    //   className: style.bgWhite,
    //   key: 'scenario',
    //   width: '5%',
    //   render: (record) => {
    //     return (
    //       <TextComponent
    //         style={{ color: '#748AA1' }}
    //         id={record.isUsedInProduction ? 'Yes' : 'No'}
    //       />
    //     );
    //   }
    // },
    {
      title: <CustomHeader title="Action" />,
      className: style.bgWhite,
      key: 'scenario',
      width: '5%',
      render: (record) => {
        return (
          <div
            className={
              editableField === undefined ||
              null ||
              editableField !== record.segmentID
                ? style.Actions
                : style.ActionsDisabled
            }>
            <a
              onClick={() => {
                if (submitMode === 'ADD') {
                  handleEditEnabledField(record.segmentID);
                  setCancelBtnToggle(false);
                } else {
                  setSubmitMode('UPDATE');
                  handleEditEnabledField(record.segmentID);
                  setCancelBtnToggle(false);
                }
              }}
              style={{ color: '#748AA1', fontSize: '18px' }}>
              <i className="fa fa-edit" />
            </a>
            <a
              onClick={() => {
                setVisible(true);
                setDeleteSegmentID(record.segmentID);
              }}
              style={{ color: '#748AA1', fontSize: '18px' }}>
              <i className="fa fa-trash" />
            </a>
          </div>
        );
      }
    }
  ];

  const handleSaveSegmentAdd = (mode) => {
    let name = '';
    let duplicateSegment = false;

    if (mode === 'ADD') {
      dataSource.forEach((data) => {
        if (data.key === editableField) {
          name = data.name;
        }
      });

      if (name === '') {
        message.error('Segment name cannot be blank');
      } else {
        customerTypeList.data.forEach((data) => {
          if (data.customer.displayName === name) {
            duplicateSegment = true;
          }
        });

        if (duplicateSegment) {
          message.error('Segment name cannot be the same!');
        } else {
          apiActions?.postCustomerType({
            data: { name: name }
          });
          setTimeout(() => {
            window.location.reload(); // Reload the page after 3 seconds
          }, 3000);
        }
      }
    }
  };

  const handleSaveSegmentUpdate = (mode) => {
    let name = '';
    let duplicateSegment = false;

    if (mode === 'UPDATE') {
      dataSource.forEach((data) => {
        if (data.key === editableField) {
          name = data.name;
        }
      });

      if (name === '') {
        message.error('Segment name cannot be blank');
      } else {
        customerTypeList.data.forEach((data) => {
          if (data.customer.displayName === name) {
            duplicateSegment = true;
          }
        });

        if (duplicateSegment) {
          message.error('Segment name cannot be the same!');
        } else {
          apiActions?.putCustomerType({
            data: { name: name, id: editableField }
          });

          setTimeout(() => {
            window.location.reload(); // Reload the page after 3 seconds
          }, 3000);
        }
      }
    }
  };

  const handleEditEnabledField = (recordID) => {
    if (editableField == null) {
      setEditableField(recordID);
    } else if (editableField === recordID) {
      setEditableField();
    } else {
      setEditableField();
    }
  };

  const handleDeleteSegment = (segmentID) => {
    setVisible(false);
    apiActions.deleteCustomerType({ id: segmentID });
  };

  const handleSegmentNameUpdate = (e, record) => {
    const updatedValue = e.target.value;
    const newData = [...dataSource];
    const updatedRecord = { ...record, name: updatedValue };
    const index = newData.findIndex((item) => record.key === item.key);
    newData.splice(index, 1, updatedRecord);
    setDataSource(newData);

    // Use a regular expression to validate the input and prevent spaces and text with spaces
    const isValid = /^[^\s]+$/.test(updatedValue);
    if (!isValid) {
      setErrorMsg('* Segment name cannot contain spaces.');
      setIsSaveDisabled(true);
    } else {
      setErrorMsg('');
      setIsSaveDisabled(false);
    }
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };

  return (
    <div className={style.listingWrapper}>
      <React.Fragment>
        <div className="">
          <div className={style.Listingheading}>
            <h3>Segments List</h3>
            <Button
              type="primary"
              id="AddSegment"
              onClick={handleAddSegment}
              disabled={disabledAddSegment}>
              Add New Segment
            </Button>
          </div>
          <Table
            className={style.table}
            columns={columns}
            dataSource={dataSource}
            scroll={{ y: 240 }}
            loading={false}
            rowKey="key"
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              onChange: (page) => setCurrentPage(page),
              showSizeChanger: true,
              pageSizeOptions: ['5', '10', '25', '50', '100'], // Options for number of records per page
              onShowSizeChange: (_, size) => handlePageSizeChange(size), // Callback when changing the page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} records` // Custom total count display
            }}
          />
        </div>
      </React.Fragment>
      <Modal
        closable={false}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setVisible(false);
              setErrorMsg('');
            }}>
            Cancel
          </Button>,
          <Button
            key="confirm"
            type="primary"
            onClick={() => handleDeleteSegment(deleteSegmentID)}>
            Confirm
          </Button>
        ]}>
        {/* Modal content goes here */}
        <div style={{ display: 'flex' }}>
          <i
            className="fa fa-regular fa-exclamation-circle"
            style={{ color: '#ff0000', width: '20px', height: '20px' }}
          />
          <h2 style={{ fontSize: '15px' }}>Delete Segment</h2>
        </div>
        <p>Are you sure you want to delete this Segment?</p>
      </Modal>
      {errorMsg && <p style={{ color: 'red' }}>{errorMsg}</p>}
      <div className={style.footerButton}>
        <Button
          key="cancel"
          onClick={() => {
            apiActions?.getCustomerType();
            setEditableField();
          }}
          disabled={cancelBtnToggle}>
          Cancel
        </Button>
        <Button
          key="confirm"
          type="primary"
          onClick={() => {
            if (submitMode == 'ADD') {
              handleSaveSegmentAdd(submitMode);
            }
            if (submitMode == 'UPDATE') {
              handleSaveSegmentUpdate(submitMode);
            }
            // Perform actions on segment addition confirmation if needed
            setVisible(false);
          }}
          disabled={isSaveDisabled} // Disable the button if no edits or new segments
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default SegmentsListing;
